export const ATTRIBUTES = {
    ACTIVE: 'active',
    DISABLED: 'disabled',
};
